module.exports = __webpack_public_path__ + "listshadow2.png?3296bb426098c03f5be496df83f227e4";